import loadable from '@loadable/component';

import './Contact.css';

export default loadable(() => {
  return import('./Contact.jsx');
});
